import { Country } from 'shared/types/types'

import { CompanyType } from '../../../types'

export const accountPlacehorders = {
  [Country.RU]: {
    bik: '123456789',
    payAccount: '12345678901234567890',
    corAccount: '12345678901234567890',
    inn: {
      [CompanyType.ip]: '123456789012',
      [CompanyType.ooo]: '1234567890',
    },
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.AM]: {
    inn: '12345678',
    payAccount: '1234567890123456',
    bik: 'ARMIAM12345',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.KZ]: {
    inn: '123456789012',
    bik: 'AB123456789',
    payAccount: 'KZ12345A678901234567',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.BY]: {
    inn: '123456789',
    bik: 'ALFABY2X',
    payAccount: 'BY12AKBB01234567890123456789',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
    legalAddress: 'Введите юридический адрес',
    gln: '1234567891234',
  },

  [Country.UZ]: {
    inn: {
      [CompanyType.ip]: '12345678901234',
      [CompanyType.ooo]: '123456789',
    },
    bik: '12345',
    payAccount: '12345678901234567890',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.KG]: {
    inn: '12345678901234',
    payAccount: '1234567890123456',
    bik: '123456',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.GE]: {
    inn: '12345678901234',
    bik: 'TBCBGE01',
    payAccount: 'GE12TB1234567890123456',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.TJ]: {
    inn: '123456789',
    payAccount: '12345678901234567890',
    bik: '123456789',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },

  [Country.TM]: {
    inn: 'Введите инн',
    payAccount: 'Введите номер счета',
    bik: 'Введите бик',
    companyName: 'Введите название компании',
    bankName: 'Введите наименование банка',
  },
}
